import { MouseEvent, memo } from 'react';
import ButtonWithLoading from './ButtonWithLoading.component';
import GridComponent from "../grid/GridComponent.component";
import Grid from '@material-ui/core/Grid';

interface Props {
    disabled: boolean;
    onClick?(e: MouseEvent<HTMLElement>): void;
    loading?: boolean
    saving?: boolean
}

function ButtonForm({ disabled, onClick, loading, saving }: Props) {

    return (
        <GridComponent spacing={2} margin='10px 0px'>
            <Grid item xs={6}>
                <ButtonWithLoading loading={loading} saving={saving} title="Salvar" fullWidth disabled={disabled} size='medium' />
            </Grid>
            <Grid item xs={6}>
                <ButtonWithLoading loading={loading} type="button" title="Voltar" size='medium' fullWidth onClick={onClick} variant='outlined' />
            </Grid>
        </GridComponent>
    );
}

export default memo(ButtonForm);